export default[
    {
        name: 'SubmissionMaterials',
        path: 'SubmissionMaterials',
        component: () => import('@/pages/BigData/TrademarkModule/TrademarkDetails/SubmissionMaterials'),
        meta: { title: '申报材料' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'ConfirmationMaterials',
        path: 'ConfirmationMaterials',
        component: () => import('@/pages/BigData/TrademarkModule/TrademarkDetails/ConfirmationMaterials'),
        meta: { title: '需确认材料' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
    {
        name: 'NteDocument',
        path: 'NteDocument',
        component: () => import('@/pages/BigData/TrademarkModule/TrademarkDetails/NteDocument'),
        meta: { title: '通知文书' },
        props(route) {
            return {
                id: route.query.id
            }
        }
    },
]